import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';

export default function addAddress(params) {
    const { baseUrl, brandId, country, address, uberToken, clientId, clientSecret } = params;

    invariant(baseUrl, 'baseUrl is a required param of addAddress()');
    invariant(brandId, 'brandId is a required param of addAddress()');
    invariant(country, 'country is a required param of addAddress()');
    invariant(address, 'address is a required param of addAddress()');
    invariant(uberToken, 'uberToken is a required param of addAddress()');
    invariant(clientId, 'clientId is a required param of addAddress()');

    const addressPayload = { ...address, addressLine: address.addressLine && address.addressLine.filter((line) => line) };

    const headers = new Headers({ 'Content-Type': 'application/json' });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/person/@self/contact`;

    return labelRequest(
        authenticatedRequest(new Request(url, { headers, method: 'POST', body: JSON.stringify(addressPayload) }), uberToken, clientId, clientSecret),
        'addAddress',
    );
}
